export default "__VITE_ASSET__Dqu00mB6__"